<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    木棉湾站<br>
站点介绍<br>
木棉湾站位于布吉镇镇政府广场南侧，深惠路中央分隔带上，为高架站。正北方向是布吉中心花园、东方半岛花园、鸿景豪苑花园等住宅区，正西方是中安大厦，西北方有布吉街道办事处、天虹商场，东南方是佳兆业商场及联美新天地商场，西南方有中海医院，正南方是深圳市木棉湾实验学校及木棉湾村。本站因布吉街道办广场种有大量木棉树而得名。此站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:00	23:34	3号线	2分15-20秒	4分30秒<br>
双龙	06:16	23:39	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:09	23:33	3号线	3分15秒	5分钟<br>
双龙	06:24	23:39	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:09	00:33	3号线	3分15秒	5分钟<br>
双龙	06:24	00:39	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
B1出入口:<br>
木棉湾村、木棉湾实验学校、华联大厦、深圳布吉佳兆业广场<br><br>
B2出入口:<br>
联美新天地华府、中国海关（布吉）、蔡兴大厦、大芬油画村<br><br>
C出入口:<br>
广场路、布沙路（西）、布吉街道办、布吉中心花园、鸿景豪苑花园、灏景明苑、中联大厦、大世纪花园<br><br>
D出入口:<br>
龙岗大道（西）、吉政路、中兴路、诚信华庭、中安大厦、文景小学、布吉天虹、深圳布吉地税局<br><br>
公交换乘信息<br><br>
B1出入口:<br>
公交站名： 木棉湾地铁站1<br>
398路,839路,977路,M203路,M224路,M233路,M265路,M268路,366路,372路,高峰专线19路,M271路,M273路,M281路,M295路,M310路，高峰专线124路,M485路，321路，322路，357路，371路，M358，M404路，M406路，M408路，323路，376路，M172，M172路，M239路，M192路，M329路，M421路，专线11，高峰换线19路，M283路，高峰专线124路，高快巴士20，高快26<br><br>
C出入口:<br>
公交站名： 木棉湾地铁站1<br>
822路,836路,839路,977路,M203路,306路,366路,M224路,M265路,M268路,M271路,M273路,M281路，M310路,M379路,M485路,高峰专线19路,高峰专线73路，M233路，高峰专线124,398路，M172路，M203路，M239路，M329路，高快巴士20，M421路，M565路，高快巴士20，高快巴士26<br><br>
D出入口:<br>
公交站名： 木棉湾地铁站2<br>
M358路,M406路,8,321,322,357,371,376,M244, M283,M404,M408,M476,323路，M192,M194,M295,M358,M406,M511<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>